import {AxiosError} from 'axios'

import {API} from '../../../networking/http'
import {QueryOptions, UseQueryOptions} from '../../helpers/types'
import {SubscriptionBooking} from '../types'

export type GetSubscriptionBookingParams = string
export type GetSubscriptionBookingQueryParams = undefined

export type GetSubscriptionBookingReturnType = SubscriptionBooking | null

type Par = QueryOptions<
  GetSubscriptionBookingParams,
  GetSubscriptionBookingQueryParams,
  GetSubscriptionBookingReturnType
>

type QueOp = UseQueryOptions<GetSubscriptionBookingReturnType, AxiosError, GetSubscriptionBookingReturnType, [string, GetSubscriptionBookingParams?]>

export const makeGetSubscriptionBookingEndpoint = (id: string) => `memberships/client/memberships/${id}`

export const getSubscriptionBooking = ({query, params: id}: Par): QueOp => ({
  queryKey: [`getSubscriptionBooking-${id}`],
  cacheTime: 1000 * 300,
  queryFn: ({queryKey: [_, config]}) => {
    if (!id) {
      return Promise.resolve(null)
    }
    return API.get<GetSubscriptionBookingQueryParams, GetSubscriptionBookingReturnType>(
      makeGetSubscriptionBookingEndpoint(id),
      {
        params: config,
        query,
      }
    ).then((res) => res.data)
  },
})
